export default function defaultSortParams(field, order) {
  // adjust sorting params
  if (field === 'id') {
    field = 'created_at'
    order = 'DESC'
  }

  return [field, order]
}
